"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.apaParams = void 0;
var namespace_1 = __importDefault(require("../namespace"));
var package_json_1 = require("../../package.json");
exports.apaParams = {
    debug: false,
    version: package_json_1.version.split(".").slice(0, 2).join("."),
    cachebreaker: '0',
    timers: {
        common: 30000,
        lazy: 120000,
        live: 5000,
    },
    timestamp: 'sec',
    paths: {
        'apa': {
            language: 'languages',
            script: 'apascripts',
            config: 'apaconfig',
            css: 'apacss',
        },
        'client': {
            script: 'clientscripts',
            config: 'clientconfig',
            css: 'clientcss'
        }
    },
    hasStyleFills: false // stylefills don't work in a cross-site-scripting environment, so they have to be avoided
};
namespace_1.default.namespace.extend('params', exports.apaParams);
